import * as React from 'react'
import { observer } from 'mobx-react'
import { RegisterModel } from './RegisterModel'
import { Select } from 'antd'
import { Countries, CANProvinces, USAStates, CompaniesModels } from '@getgreenline/companies'
import { GlobalStore } from '@/app/stores/GlobalStore'
import { StateOrProvinceDropdown } from '../Dashboard/DashboardSettings/SingleLocation/StateOrProvinceDropdown'
import { Country } from '@getgreenline/homi-shared'

interface Props {
  registerModel: RegisterModel
}

@observer
export class Company extends React.Component<Props, {}> {
  componentDidMount() {
    this.focusInput()
  }

  focusInput() {
    const inputs = document.getElementsByTagName('input')
    if (inputs.length > 0) {
      inputs[0].focus()
    }
  }

  get timezoneOptions() {
    return [
      {
        label: 'Pacific',
        value: 'America/Vancouver',
      },
      {
        label: 'Mountain',
        value: 'America/Edmonton',
      },
      {
        label: 'Central',
        value: 'America/Regina',
      },
      {
        label: 'Eastern',
        value: 'America/Toronto',
      },
      {
        label: 'Atlantic',
        value: 'America/Halifax',
      },
    ]
  }

  render() {
    const registerModel = this.props.registerModel
    const country: Country = registerModel.country === Countries.CAN ? 'Canada' : 'USA'

    return (
      <div className='animated fadeInRight'>
        <h3>Store setup</h3>
        <p className='text-muted'>
          Let's get your store details. What is the name of your business?
        </p>
        <div className='form-group'>
          <input
            type='text'
            className='form-control form-control-lg'
            placeholder='Your store name'
            value={registerModel.companyName}
            onChange={(e) => (registerModel.companyName = e.target.value)}
          />
        </div>

        {GlobalStore.isBlazeApp && (
          <div className='form-group'>
            <div>
              <label>Country</label>
            </div>

            <Select<Countries>
              className='w-100'
              value={registerModel.country}
              allowClear={false}
              onChange={(country) => {
                registerModel.country = country
                registerModel.province = country === Countries.CAN ? CANProvinces.AB : USAStates.AK
              }}
            >
              {Object.values(Countries)
                .sort()
                .map((country) => (
                  <Select.Option key={country} value={country}>
                    {country}
                  </Select.Option>
                ))}
            </Select>
          </div>
        )}

        <div className='form-group'>
          <StateOrProvinceDropdown
            stateOrProvince={registerModel.province as CompaniesModels.Provinces}
            onChange={(province) =>
              (registerModel.province = province as CompaniesModels.Provinces)
            }
            country={country}
          />
        </div>

        <div className='form-group'>
          <div>
            <label>Timezone</label>
          </div>

          <Select<string>
            className='w-100'
            value={registerModel.timezone}
            placeholder='Timezone'
            allowClear={false}
            onChange={(timezone) => (registerModel.timezone = timezone)}
          >
            {this.timezoneOptions.map((option, index) => (
              <Select.Option key={index} value={option.value}>
                {option.label}
              </Select.Option>
            ))}
          </Select>
        </div>
      </div>
    )
  }
}
